import { useUserStore } from '@/store/userSlice';

const BASE_URL = import.meta.env.VITE_API_URL ?? '';

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = useUserStore.getState().token;
  const headers = new Headers(init.headers);

  if (token) headers.set('Authorization', `Bearer ${token}`);
  // для FormData Content-Type выставляет fetch сам (с boundary multipart)
  if (init.body && !(init.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  return fetch(`${BASE_URL}${path}`, { ...init, headers });
}
